export const netEasyCheckoutKey = process.env.NEXT_PUBLIC_NETSEASY_CHECKOUT_KEY;
export const netsEastCheckoutUrl = process.env.NEXT_PUBLIC_NETSEASY_CHECKOUT_URL;
